export const ICS_233_EXPORT_FORMNAME = 'ICS_233_CG' as const;
